import { boolean, number, object, string } from "yup";
import { stringMax } from "./utils";

const ACCOUNT_NUMBER_MESSAGE = "1 à 20 lettres ou chiffres, sans espace";

export const bankSchema = object({
  nom: stringMax(250).optional(),
  institution_id: string().optional(),
  account_id: string().optional(),
  id_compte: number().optional(),
  id_profile_nom: number().optional(),
  montant: number().optional(),
  alert: number().optional(),
  compte_gestion: boolean().optional(),
  accounting_account_number: string()
    .nullable()
    .matches(/^[A-Za-z0-9]*$/, ACCOUNT_NUMBER_MESSAGE)
    .max(20, ACCOUNT_NUMBER_MESSAGE),
});

export const BANK_INITIAL_VALUES = {
  nom: "",
  institution_id: "",
  account_id: "",
  id_profile_nom: "",
  montant: "",
  alert: "",
  compte_gestion: false,
  accounting_account_number: "",
};
